// /app/frontend/src/components/frugal-v2/hooks/useCashflowAlerts.js
// Polls cashflow projection and returns array of bell alerts when balance is forecast negative

import { useState, useEffect } from 'react';

const API = process.env.REACT_APP_BACKEND_URL;

export const useCashflowAlerts = (token) => {
  const [alerts, setAlerts] = useState([]);

  useEffect(() => {
    if (!token) return;
    let cancelled = false;

    const fetchAlerts = async () => {
      try {
        const res = await fetch(`${API}/api/v2/frugal/reports/cashflow`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (!res.ok) return;
        const data = await res.json();
        const cashAlerts = (data?.alerts || []).map((a) => ({
          type: 'cashflow',
          date: a.date,
          balance: a.balance
        }));
        // Single consolidated alert is enough for the bell (avoid spamming)
        if (!cancelled) {
          setAlerts(cashAlerts.length > 0 ? [cashAlerts[0]] : []);
        }
      } catch {
        if (!cancelled) setAlerts([]);
      }
    };

    fetchAlerts();
    const interval = setInterval(fetchAlerts, 5 * 60 * 1000); // refresh every 5 min
    return () => { cancelled = true; clearInterval(interval); };
  }, [token]);

  return alerts;
};

export default useCashflowAlerts;
